/** @format */

import getConfig from "next/config"

const HYPERFAISEUR_APP_ID = "8"
const regexp = /^http[s]?:[/]{2}[^/]*/i

export const navigationToLoginPage = () => {
	const path = window.location.href.replace(regexp, "")

	if (path.startsWith("/404")) {
		return // No redirect for 404 page
	}
	const loginUrl = getConfig().publicRuntimeConfig.mySelogerProBaseUrl as string
	const param = encodeURIComponent(HYPERFAISEUR_APP_ID + path)

	const newUrl = `${loginUrl}/login?redirectTo=${param}`

	window.location.assign(newUrl)
}
